import React from 'react';

import UnlimitedUserLimitSrc from './assets/UnlimitedUserLimit.png';

export const UnlimitedUserLimit = () => {
	return (
		<img alt="Adding users to a Confluence instance" src={UnlimitedUserLimitSrc} width="70%" />
	);
};
